export default __webpack_public_path__ + "static/media/l.db010a91.jpeg";